import React, {useState} from "react";
import Modal from '../../component/Inc/Modal';
import Upload from "../../component/Inc/Upload";
function PopManageCompany(props) {
  const { open, close } = props; 
	const listItems = ['㈜글로벌 이지수능', '㈜이지수능교육', '㈜이지수능교육', '㈜글로벌 이지수능', '㈜글로벌 이지수능', '㈜글로벌 이지수능', '㈜글로벌 이지수능'];
	const [selectedItem, setSelectedItem] = useState(null);

  return (
    <Modal open={open} close={close} type="com_input com_manage_company">
      <h2 className='pop_tit'>법인관리</h2>
      <div className="content_container scroll">
				<ul className="com_scroll_list pick">
						{listItems.map((item, index) => (
							<li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
								{item}
							</li>
						))}
					</ul>
        <ul className='com_input_sec'>
          <li className='tit_field'>법인명</li>
          <li className='input_field'>
            <input type="text" className="input" placeholder=""/>
          </li>
          <li className='tit_field'>사업자 번호</li>
          <li className='input_field'>
            <input type="text" className="input" placeholder="000-00-0000"/>
          </li>
          
          <li className='tit_field'>사업자 등록증</li>
          <li className="input_field">
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray s wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button
                  type="button"
                  className="btn_del_file"
                  onClick={() => {}}
                ></button>
                <button
                  type="button"
                  className="btn_down"
                  onClick={() => {}}
                ></button>
              </p>
            </div>
          </li>
        </ul>
        <hr className="com_divider" />
				<div className="com_blue_txt">*이전할 금액에서 지목 수수료는 뺀 금액이 전달 됩니다.</div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopManageCompany;